export default __webpack_public_path__ + "static/media/icon-phone.30534d33.svg";